import React from 'react';
import { MapPin, ExternalLink } from 'lucide-react';
import { apartmentInfo, contactInfo } from '../data/mock';

const Location = () => {
  return (
    <section id="lokacija" className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-sage-600 text-sm font-medium tracking-wider mb-2">Lokacija</p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900">
            Gdje se nalazimo
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-xl h-96 lg:h-auto">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2879.8825!2d18.5697!3d43.7367!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475f5a8c8c8c8c8c%3A0x8c8c8c8c8c8c8c8c!2sAparthotel%20Vucko%20Jahorina!5e0!3m2!1shr!2sba!4v1702500000000"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '400px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Lokacija apartmana - Jahorina"
            />
          </div>

          {/* Info */}
          <div>
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <div className="flex items-start gap-4 mb-6">
                <div className="bg-sage-100 p-3 rounded-xl">
                  <MapPin className="text-sage-600" size={24} />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-1">Adresa</h3>
                  <p className="text-gray-600">{contactInfo.address}</p>
                </div>
              </div>

              <p className="text-gray-600 leading-relaxed mb-6">
                Objekt PeakView 508 Cozy Alpine Apartment - u sklopu hotela Vucko Jahorina smješten je u Jahorini na 27 km od znamenitosti Sebilj i 27 km od znamenitosti Baščaršija te nudi smještaj s opremom kao što su besplatan WiFi i TV ravnog ekrana. Ovaj objekt nalazi se na 26 km od znamenitosti Latinska ćuprija te ima terasu i besplatno privatno parkiralište.
              </p>

              <p className="text-gray-600 leading-relaxed mb-6">
                Ovaj apartman s klima-uređajem ima izlaz na balkon s pogledom na planinu te sadrži spavaću sobu (1). U ovom apartmanu nude se ručnici i posteljina.
              </p>

              <p className="text-gray-600 leading-relaxed mb-6">
                Na 30 km od objekta PeakView 508 Cozy Alpine Apartment - u sklopu hotela Vucko Jahorina nalazi se znamenitost Sarajevski ratni tunel, dok se znamenitost Sarajevo Cable Car nalazi na 26 km od objekta.
              </p>

              <a
                href="https://www.google.com/maps/search/?api=1&query=Aparthotel+Vucko+Jahorina"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-sage-600 hover:bg-sage-700 text-white px-6 py-3 rounded-lg font-medium transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                <ExternalLink size={18} />
                Otvori u Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;